import React from "react";
import {
  fill_heart,
  heart_icon,
  lock_icon,
  subscription_icon,
} from "../../../../assets";
import { Link, useNavigate } from "react-router-dom";
import { GoDotFill } from "react-icons/go";
import { updateFavoriteListHandler } from "./LikeUnlikeHeart";
import { GroupCardSkeleton } from "../../../../shimmer/groups/GroupsListingShimmer";
import InfiniteScroll from "react-infinite-scroll-component";

const JoinedGroup = ({ groupList, fetchMoreData, hasMore, setGroupList }) => {
  const navigate = useNavigate();
  //--------navigate-details-page--------------
  const navigateDetailsPage = (id) => {
    navigate(`/dashboard/group/detail/${id}`);
  };
  // console.log('groupList', groupList)
  return (
    <>
      <div className="CategoriesGroupsList_parent">
        <div id="scrollableContainer" className="CategoriesGroupsList_cards">
          <InfiniteScroll
            dataLength={groupList.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={<GroupCardSkeleton count={5} />}
            endMessage={
              <p style={{ textAlign: "center", margin: "25px" }}>
                <b>No more data to display</b>
              </p>
            }
            scrollableTarget="scrollableContainer"
          >
            <div className="health_hub_cards">
              {groupList && groupList.length > 0
                ? groupList?.map((data, ind) => (
                  <div key={ind} className="health_hub_img">
                    {/* <Link to={`/dashboard/group/detail/${data?._group?._id}`} ></Link> */}

                    <div
                      onClick={() => navigateDetailsPage(data?._group?._id)}
                      className="image_containerss pointer-cursor"
                    >
                      <img src={data?._group?.coverImage} />
                      <div className="health_hub_img_text">
                        <h6>{data?._group?.name}</h6>
                        <p>
                          {data?._group?.newFeeds?.count > 0 ? (
                            <>
                              <GoDotFill className="live_dot" />
                              {`${data?._group?.newFeeds?.count} New Post${data?._group?.newFeeds?.count > 1 ? "s" : ""
                                }`}
                            </>
                          ) : null}
                        </p>
                      </div>
                    </div>

                    <div className="health_hub_containt">
                      <span>{data?._group?.categoryName}</span>

                      <figure className="health_hub_icons">
                        {data?._group?.type === "SUBSCRIPTION" && (
                          <img src={subscription_icon} className="lockimg" />
                        )}
                        {data?._group?.type === "PRIVATE" && (
                          <img src={lock_icon} className="lockimg" />
                        )}
                        <img
                          src={
                            data?.favoriteGroup?.status === "ACTIVE"
                              ? fill_heart
                              : heart_icon
                          }
                          className="heartimg"
                          onClick={() =>
                            updateFavoriteListHandler(
                              data?._group?._id,
                              setGroupList,
                              data?.favoriteGroup?.status === "ACTIVE"
                                ? "INACTIVE"
                                : "ACTIVE"
                            )
                          }
                        />
                      </figure>
                    </div>
                  </div>
                ))
                : null}
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </>
  );
};

export default JoinedGroup;
